
import React from 'react';
import { Tabs, TabsContent } from '@/components/ui/tabs';
import { ScrollArea } from '@/components/ui/scroll-area';
import Header from '@/components/Header';
import { DocumentationTabs } from '@/components/documentation/DocumentationTabs';
import { IntroSection } from '@/components/documentation/sections/IntroSection';
import { BrandingSection } from '@/components/documentation/sections/BrandingSection';
import { PromptingSection } from '@/components/documentation/sections/PromptingSection';

// Lazy load other section components
const TemplatesSection = React.lazy(() => import('@/components/documentation/sections/TemplatesSection'));
const DocumentsSection = React.lazy(() => import('@/components/documentation/sections/DocumentsSection'));
const OffersSection = React.lazy(() => import('@/components/documentation/sections/OffersSection'));
const SignatureSection = React.lazy(() => import('@/components/documentation/sections/SignatureSection'));
const RoadmapSection = React.lazy(() => import('@/components/documentation/sections/RoadmapSection'));
const FAQSection = React.lazy(() => import('@/components/documentation/sections/FAQSection'));

const Documentation: React.FC = () => {
  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-black to-gray-900 text-white">
      <Header />
      <div className="flex-1 overflow-hidden p-4 md:p-8">
        <div className="max-w-4xl mx-auto pt-16">
          <h1 className="text-3xl font-bold mb-2">Dokumentation</h1>
          <p className="text-gray-400 mb-6">Umfassende Anleitung für die Nutzung der Plattform</p>

          <Tabs defaultValue="intro" className="w-full">
            <DocumentationTabs />
            
            <ScrollArea className="h-[calc(100vh-300px)]">
              <TabsContent value="intro">
                <IntroSection />
              </TabsContent>
              
              <TabsContent value="branding">
                <BrandingSection />
              </TabsContent>
              
              <TabsContent value="prompting">
                <PromptingSection />
              </TabsContent>

              <React.Suspense fallback={<div>Loading...</div>}>
                <TabsContent value="templates">
                  <TemplatesSection />
                </TabsContent>

                <TabsContent value="documents">
                  <DocumentsSection />
                </TabsContent>

                <TabsContent value="offers">
                  <OffersSection />
                </TabsContent>

                <TabsContent value="signature">
                  <SignatureSection />
                </TabsContent>

                <TabsContent value="roadmap">
                  <RoadmapSection />
                </TabsContent>

                <TabsContent value="faq">
                  <FAQSection />
                </TabsContent>
              </React.Suspense>
            </ScrollArea>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
